// src/features/leases/components/SpacebaseBanner.jsx
//
// LEASE-SOURCE-LANGUAGE: Replaced misleading link/sync copy with honest
// provenance chips. Three states:
//   1. lastCsvImportedAt set    → "Source: Spacebase CSV · imported {date}"
//                                  + "Spacebase ref: {id}" inline
//   2. leaseIdSpacebase only    → "Spacebase ref: {id}" in neutral gray
//   3. Neither                  → "Source: Manual entry" in neutral gray
//
// No amber warning, no 🔗 emoji, no Link button — these implied a live
// integration that does not exist.

import React from "react";
import { T } from "../../../app/tokens.js";
import { parseDateOnly } from "../leaseTabConfig.js";

function fmtDate(d) {
  if (!d) return "—";
  const dt = parseDateOnly(d);
  if (!dt) return String(d);
  return dt.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
}

export function SpacebaseBanner({ leaseIdSpacebase, lastCsvImportedAt }) {
  if (lastCsvImportedAt && leaseIdSpacebase) {
    return (
      <span
        data-testid="source-provenance-imported"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          fontSize: T.fsXxs,
          color: T.mid,
        }}
      >
        <span style={{ color: T.dark, fontWeight: T.fwSemibold }}>
          Source: Spacebase CSV
        </span>
        <span aria-hidden="true">·</span>
        <span>imported {fmtDate(lastCsvImportedAt)}</span>
        <span aria-hidden="true">·</span>
        <span>
          Spacebase ref:{" "}
          <code style={{ background: "transparent", padding: 0, fontSize: T.fsXxs, color: T.mid }}>
            {leaseIdSpacebase}
          </code>
        </span>
      </span>
    );
  }

  if (leaseIdSpacebase) {
    return (
      <span
        data-testid="source-provenance-ref-only"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 4,
          fontSize: T.fsXxs,
          color: T.mid,
        }}
      >
        Spacebase ref:{" "}
        <code style={{ background: "transparent", padding: 0, fontSize: T.fsXxs, color: T.mid }}>
          {leaseIdSpacebase}
        </code>
      </span>
    );
  }

  return (
    <span
      data-testid="source-provenance-manual"
      style={{
        display: "inline-flex",
        alignItems: "center",
        fontSize: T.fsXxs,
        color: T.mid,
      }}
    >
      Source: Manual entry
    </span>
  );
}
